import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsAttachmentsViewStaticData } from "src/views/ProcedureTypeSettingsAttachmentsView/constants"
import { ProcedureTypeSettingsAttachmentsView } from "src/views/ProcedureTypeSettingsAttachmentsView/ProcedureTypeSettingsAttachmentsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/attachments",
)({
	component: ProcedureTypeSettingsAttachmentsView,
	staticData: procedureTypeSettingsAttachmentsViewStaticData,
})
